import { render, staticRenderFns } from "./handwritten.vue?vue&type=template&id=036c5a66&scoped=true&"
import script from "./handwritten.vue?vue&type=script&lang=js&"
export * from "./handwritten.vue?vue&type=script&lang=js&"
import style0 from "./handwritten.vue?vue&type=style&index=0&id=036c5a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c5a66",
  null
  
)

export default component.exports